export const setPlaceCount = ({ placeCount, isLoading }) => state => {
  return {
    ...state,
    places: {
      ...state.places,
      pagination: {
        ...state.places.pagination,
        isLoading:
          isLoading === undefined
            ? state.unvisitedPlaces.pagination.isLoading
            : isLoading,
        itemCount: placeCount,
        pageCount: Math.ceil(placeCount / state.places.pagination.pageSize),
      },
    },
  };
};
